module.exports = __webpack_public_path__ + "img/Illustration.6cfd6fc7.png";